import { UnreadNotification } from 'hooks/useUnreadNotifications';
import CloseIcon from 'svg/CloseIcon';
import { ButtonText } from 'components/Button';
import classNames from 'styles/utils/classNames';
import NotificationTypeSelector from './NotificationTypeSelector';

interface Props {
  notification: UnreadNotification;
  isVisible: boolean;
  onDismiss: () => void;
}

/** The same card the notification centre renders, floated as a toast. */
export default function NotificationToast({ notification, isVisible, onDismiss }: Props) {
  return (
    <div
      onClick={onDismiss}
      className={classNames(
        'pointer-events-auto relative w-full max-w-sm transition-all duration-200',
        isVisible ? 'translate-y-0 opacity-100' : '-translate-y-2 opacity-0',
      )}
    >
      <div className="overflow-hidden rounded-2xl shadow-popover">
        <NotificationTypeSelector notification={notification} />
      </div>
      <ButtonText
        onClick={(event) => {
          event.stopPropagation();
          onDismiss();
        }}
        aria-label="Dismiss"
        className="absolute -right-2 -top-2 flex h-6 w-6 items-center justify-center rounded-full bg-color-bg-lightmode-primary text-color-text-lightmode-secondary shadow-popover dark:bg-color-bg-darkmode-primary dark:text-color-text-darkmode-secondary"
      >
        <CloseIcon className="h-3.5 w-3.5" />
      </ButtonText>
    </div>
  );
}
